/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// deno-lint-ignore-file

import Axios, { AxiosPromise, AxiosRequestConfig, AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { logEvent, logError } from '../utils/logger-utils';
import { Make } from '../components/common/RetryOptions';

interface AxiosInstanceWithRetry {
  axiosInstance: AxiosInstance;
  retryCount: Make;
}

const createAxios = (): AxiosInstance => {
  const instance = Axios.create({
    baseURL: '',
    paramsSerializer: (params: any) =>
      encodeParams(params, null, {
        allowDots: true,
        arrayFormat: 'repeat',
      }),
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.isAxiosError) {
        // Enhance error name and message
        const url = error.config?.url || 'unknown';
        const method = error.config?.method?.toUpperCase() || 'UNKNOWN';
        const status = error.response?.status || 'Network Error';

        const enhancedError = new Error(`AxiosError ${method} ${url} [${status}]`) as any;
        enhancedError.name = 'AxiosError';
        enhancedError.isAxiosError = true;

        // Preserve the original Axios error structure
        enhancedError.response = error.response;
        enhancedError.config = error.config;

        // Add enhanced information
        enhancedError.cause = {
          url: url,
          method: method,
          status: status,
          responseData: error.response?.data,
          originalError: error,
        };

        return Promise.reject(enhancedError);
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

const getConfiguredRetryAxios = (retries: number): AxiosInstance => {
  let instance = createAxios();
  axiosRetry(instance, {
    retries,
    retryCondition: axiosRetry.isRetryableError,
    retryDelay: (retryCount, error) => axiosRetry.exponentialDelay(retryCount, error, 1000),
    onRetry: (retryCount, error, requestConfig) => {
      logEvent({
        message: `Retry attempt #${retryCount} for ${requestConfig.url}`,
        level: 'warning',
        extra: { requestUrl: requestConfig.url, fromUrl: window.location.href },
      });
      logError(error);
    },
  });
  return instance;
};

const initRetryAxiosIntances = (): AxiosInstanceWithRetry[] => {
  return Object.values(Make)
    .filter((retryCount): retryCount is number => typeof retryCount === 'number' && retryCount > 0)
    .map((retryCount) => ({
      axiosInstance: getConfiguredRetryAxios(retryCount),
      retryCount,
    }));
};

const axiosRetryInstancesWithRetry: AxiosInstanceWithRetry[] = initRetryAxiosIntances();

export const axios: AxiosInstance = createAxios();
export const axiosRetryInstances: AxiosInstance[] = axiosRetryInstancesWithRetry.map(
  (inst) => inst.axiosInstance
);

export const getAxiosInstance = (retries: Make = 0): AxiosInstance => {
  return retries > 0
    ? (axiosRetryInstancesWithRetry.find((inst) => inst.retryCount === retries)?.axiosInstance ??
        axios)
    : axios;
};

export const payServiceClient = {
  /**
   */
  getCountriesWithCodes(
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<CountryWithCode[]> {
    let url = `/api/payService/country`;

    return getAxiosInstance(retries).request<CountryWithCode[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   */
  getGoogleAnalyticsSettings(
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<IGoogleAnalyticsSettings> {
    let url = `/api/payService/googleAnalytics`;

    return getAxiosInstance(retries).request<IGoogleAnalyticsSettings>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   */
  getUserInfo(retries: Make = Make.NoRetry, $config?: AxiosRequestConfig): AxiosPromise<string> {
    let url = `/api/payService/getUserInfo`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};

export const adyenPaymentPageClient = {
  /**
   * @param paymentId  (API name: PaymentId) * @param redirectResult  (API name: RedirectResult) */
  checkRedirectResult(
    paymentId: string,
    redirectResult: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<CheckRedirectResultResponse> {
    let url = `/api/adyen/payment/check-redirect-result`;

    return getAxiosInstance(retries).request<CheckRedirectResultResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
        RedirectResult: redirectResult,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) * @param shopperLocale  (API name: ShopperLocale) */
  getPayFormData(
    paymentId: string,
    shopperLocale: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayFormDataAdyen> {
    let url = `/api/adyen/data`;

    return getAxiosInstance(retries).request<PayFormDataAdyen>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
        ShopperLocale: shopperLocale,
      },
      ...$config,
    });
  },

  /**
   * @param reference   */
  isTransactionCancelled(
    reference: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<boolean> {
    let url = `/api/adyen/payment/is-transaction-cancelled`;

    return getAxiosInstance(retries).request<boolean>({
      url: url,
      method: 'GET',
      params: {
        reference: reference,
      },
      ...$config,
    });
  },
};

export const alePayPaymentClient = {
  /**
   * @param request   */
  finishPayment(
    request: AlePayFinishPaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<AlePayFinishPaymentResponse> {
    let url = `/api/alePay/finishPayment`;

    return getAxiosInstance(retries).request<AlePayFinishPaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<AlePayPayFormDataResponse> {
    let url = `/api/alePay/formData`;

    return getAxiosInstance(retries).request<AlePayPayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: AlePayInitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<AlePayInitiatePaymentResponse> {
    let url = `/api/alePay/initiatePayment`;

    return getAxiosInstance(retries).request<AlePayInitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

export const instalmentPlanClient = {
  /**
   * @param instalmentPlanId   */
  cancel(
    instalmentPlanId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<string> {
    let url = `/api/instalmentPlan/cancel`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'POST',
      params: {
        instalmentPlanId: instalmentPlanId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  generateUpdatePaymentMethodUrl(
    request: GenerateInstalmentPlanUpdatePaymentMethodUrlRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GenerateInstalmentPlanUpdatePaymentMethodUrlResponse> {
    let url = `/api/instalmentPlan/generateUpdatePaymentMethodUrl`;

    return getAxiosInstance(retries).request<GenerateInstalmentPlanUpdatePaymentMethodUrlResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param instalmentPlanId   */
  getConfiguration(
    instalmentPlanId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<InstalmentPlanConfigurationResult> {
    let url = `/api/instalmentPlan/configuration`;

    return getAxiosInstance(retries).request<InstalmentPlanConfigurationResult>({
      url: url,
      method: 'GET',
      params: {
        instalmentPlanId: instalmentPlanId,
      },
      ...$config,
    });
  },

  /**
   * @param instalmentPlanId   */
  getErrorPageInfo(
    instalmentPlanId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ErrorPageInstalmentPlanInfo> {
    let url = `/api/instalmentPlan/errorPageInfo`;

    return getAxiosInstance(retries).request<ErrorPageInstalmentPlanInfo>({
      url: url,
      method: 'GET',
      params: {
        instalmentPlanId: instalmentPlanId,
      },
      ...$config,
    });
  },

  /**
   * @param token  (API name: Token) * @param entityId  (API name: EntityId) */
  getInstalmentPlanPaymentUpdateData(
    token: string,
    entityId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<InstalmentPlanPaymentUpdateData> {
    let url = `/api/instalmentPlan/paymentUpdateData`;

    return getAxiosInstance(retries).request<InstalmentPlanPaymentUpdateData>({
      url: url,
      method: 'GET',
      params: {
        Token: token,
        EntityId: entityId,
      },
      ...$config,
    });
  },

  /**
   * @param instalmentPlanId   */
  getStatus(
    instalmentPlanId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<InstalmentPlanStatusData> {
    let url = `/api/instalmentPlan/status`;

    return getAxiosInstance(retries).request<InstalmentPlanStatusData>({
      url: url,
      method: 'GET',
      params: {
        instalmentPlanId: instalmentPlanId,
      },
      ...$config,
    });
  },

  /**
   * @param instalmentPlanId   */
  getSupportContactInformation(
    instalmentPlanId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SupportContactInformationRecord> {
    let url = `/api/instalmentPlan/supportContactInformation`;

    return getAxiosInstance(retries).request<SupportContactInformationRecord>({
      url: url,
      method: 'GET',
      params: {
        instalmentPlanId: instalmentPlanId,
      },
      ...$config,
    });
  },

  /**
   * @param instalmentPlanId   */
  timeout(
    instalmentPlanId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<string> {
    let url = `/api/instalmentPlan/timeout`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'POST',
      params: {
        instalmentPlanId: instalmentPlanId,
      },
      ...$config,
    });
  },
};

export const paymentClient = {
  /**
   * @param paymentId   */
  cancel(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<string> {
    let url = `/api/payment/cancel`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'POST',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  cancelAsynchronousPayment(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<string> {
    let url = `/api/payment/cancelAsyncPayment`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'POST',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  checkedCancel(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<string> {
    let url = `/api/payment/checkedCancel`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'POST',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  choosePaymentMethod(
    request: ChoosePaymentMethodRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ChoosePaymentMethodResult> {
    let url = `/api/payment/choosePaymentMethod`;

    return getAxiosInstance(retries).request<ChoosePaymentMethodResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getErrorPagePaymentInfo(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ErrorPagePaymentInfo> {
    let url = `/api/payment/paymentInfo`;

    return getAxiosInstance(retries).request<ErrorPagePaymentInfo>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getPaymentActiveConfigurations(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ActiveConfigurationResult[]> {
    let url = `/api/payment/activeConfigurations`;

    return getAxiosInstance(retries).request<ActiveConfigurationResult[]>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getPaymentConfiguration(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentConfigurationResult> {
    let url = `/api/payment/configuration`;

    return getAxiosInstance(retries).request<PaymentConfigurationResult>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getPaymentDataForAnalytics(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentInformation> {
    let url = `/api/payment/dataForAnalytics`;

    return getAxiosInstance(retries).request<PaymentInformation>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getStatus(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentStatusData> {
    let url = `/api/payment/status`;

    return getAxiosInstance(retries).request<PaymentStatusData>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getStatusPagePaymentInfo(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<StatusPagePaymentInfo> {
    let url = `/api/payment/statusPagePaymentInfo`;

    return getAxiosInstance(retries).request<StatusPagePaymentInfo>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getSupportContactInformation(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SupportContactInformationRecord> {
    let url = `/api/payment/supportContactInformation`;

    return getAxiosInstance(retries).request<SupportContactInformationRecord>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getTimeoutValue(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<number> {
    let url = `/api/payment/timeoutValue`;

    return getAxiosInstance(retries).request<number>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  timeoutPayment(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<string> {
    let url = `/api/payment/timeoutPaymentAsync`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'POST',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },
};

export const subscriptionClient = {
  /**
   * @param subscriptionId   */
  cancel(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<string> {
    let url = `/api/subscription/cancel`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'POST',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  getErrorPageSubscriptionInfo(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<ErrorPageSubscriptionInfo> {
    let url = `/api/subscription/errorPageInfo`;

    return getAxiosInstance(retries).request<ErrorPageSubscriptionInfo>({
      url: url,
      method: 'GET',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  getStatus(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionStatusData> {
    let url = `/api/subscription/status`;

    return getAxiosInstance(retries).request<SubscriptionStatusData>({
      url: url,
      method: 'GET',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  getSubscriptionConfiguration(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionConfigurationResult> {
    let url = `/api/subscription/configuration`;

    return getAxiosInstance(retries).request<SubscriptionConfigurationResult>({
      url: url,
      method: 'GET',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param token  (API name: Token) * @param entityId  (API name: EntityId) */
  getSubscriptionPaymentUpdateData(
    token: string,
    entityId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionPaymentUpdateData> {
    let url = `/api/subscription/paymentUpdateData`;

    return getAxiosInstance(retries).request<SubscriptionPaymentUpdateData>({
      url: url,
      method: 'GET',
      params: {
        Token: token,
        EntityId: entityId,
      },
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  getSubscriptionStatus(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionStatusResponse> {
    let url = `/api/subscription/getSubscriptionStatus`;

    return getAxiosInstance(retries).request<SubscriptionStatusResponse>({
      url: url,
      method: 'GET',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  getSubscriptionSupportContactInformation(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SupportContactInformationRecord> {
    let url = `/api/subscription/supportContactInformation`;

    return getAxiosInstance(retries).request<SupportContactInformationRecord>({
      url: url,
      method: 'GET',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  getTimeoutValue(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<number> {
    let url = `/api/subscription/timeoutValue`;

    return getAxiosInstance(retries).request<number>({
      url: url,
      method: 'GET',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  timeoutSubscription(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<string> {
    let url = `/api/subscription/timeoutSubscription`;

    return getAxiosInstance(retries).request<string>({
      url: url,
      method: 'POST',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },
};

export const cyberSourcePaymentClient = {
  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<CyberSourcePayFormDataResponse> {
    let url = `/api/cybersource/data`;

    return getAxiosInstance(retries).request<CyberSourcePayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  startPayment(
    request: CyberSourceStartPaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<CyberSourceStartPaymentResponse> {
    let url = `/api/cybersource/payment`;

    return getAxiosInstance(retries).request<CyberSourceStartPaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

export const dokuV2PaymentPageClient = {
  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<DokuV2FormDataResponse> {
    let url = `/api/dokuv2/data`;

    return getAxiosInstance(retries).request<DokuV2FormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: DokuV2InitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<DokuV2InitiatePaymentResponse> {
    let url = `/api/dokuv2/initiatePayment`;

    return getAxiosInstance(retries).request<DokuV2InitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  verifyTransaction(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<DokuV2VerifyTransactionResponse> {
    let url = `/api/dokuv2/verifyTransaction`;

    return getAxiosInstance(retries).request<DokuV2VerifyTransactionResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },
};

export const dragonPayPaymentPageClient = {
  /**
   * @param request   */
  cancelTransaction(
    request: PaymentIdRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    let url = `/api/dragonPay/cancelTransaction`;

    return getAxiosInstance(retries).request<unknown>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  enforceStatusCheck(
    request: PaymentIdRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EnforcePspStatusResult> {
    let url = `/api/dragonPay/enforceStatusCheck`;

    return getAxiosInstance(retries).request<EnforcePspStatusResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<DragonPayPayFormDataResponse> {
    let url = `/api/dragonPay/data`;

    return getAxiosInstance(retries).request<DragonPayPayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: DragonPayInitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<DragonPayInitiatePaymentResponse> {
    let url = `/api/dragonPay/initiatePayment`;

    return getAxiosInstance(retries).request<DragonPayInitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param transactionId   */
  verifyTransaction(
    transactionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<DragonPayVerifyTransactionResponse> {
    let url = `/api/dragonPay/verifyTransaction`;

    return getAxiosInstance(retries).request<DragonPayVerifyTransactionResponse>({
      url: url,
      method: 'GET',
      params: {
        transactionId: transactionId,
      },
      ...$config,
    });
  },
};

export const esewaPaymentClient = {
  /**
   * @param paymentId  (API name: PaymentId) */
  createPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayFormDataEsewa> {
    let url = `/api/eSewa/data`;

    return getAxiosInstance(retries).request<PayFormDataEsewa>({
      url: url,
      method: 'POST',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  enforceStatusCheck(
    request: PaymentIdRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EnforcePspStatusResult> {
    let url = `/api/eSewa/enforceStatusCheck`;

    return getAxiosInstance(retries).request<EnforcePspStatusResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  verifyTransaction(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EsewaVerifyTransactionResponse> {
    let url = `/api/eSewa/verifyTransaction`;

    return getAxiosInstance(retries).request<EsewaVerifyTransactionResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },
};

export const fiuuPaymentPageClient = {
  /**
   * @param paymentId  (API name: PaymentId) */
  getChannels(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<FiuuChannelsResponse> {
    let url = `/api/fiuu/channels`;

    return getAxiosInstance(retries).request<FiuuChannelsResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<FiuuPayFormDataResponse> {
    let url = `/api/fiuu/data`;

    return getAxiosInstance(retries).request<FiuuPayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: FiuuInitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<FiuuInitiatePaymentResponse> {
    let url = `/api/fiuu/initiatePayment`;

    return getAxiosInstance(retries).request<FiuuInitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

export const flutterwavePaymentPageClient = {
  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<FlutterwavePayFormDataResponse> {
    let url = `/api/flutterwave/data`;

    return getAxiosInstance(retries).request<FlutterwavePayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: FlutterwaveInitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<FlutterwaveInitiatePaymentResponse> {
    let url = `/api/flutterwave/initiatePayment`;

    return getAxiosInstance(retries).request<FlutterwaveInitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  verifyTransaction(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<FlutterwaveVerifyTransactionResponse> {
    let url = `/api/flutterwave/verifyTransaction`;

    return getAxiosInstance(retries).request<FlutterwaveVerifyTransactionResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },
};

export const jpmPaymentClient = {
  /**
   * @param request   */
  checkPaymentStatus(
    request: CheckPaymentStatusRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    let url = `/api/jpm/checkCheckoutStatus`;

    return getAxiosInstance(retries).request<unknown>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  enforceStatusCheck(
    request: PaymentIdRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EnforcePspStatusResult> {
    let url = `/api/jpm/enforceStatusCheck`;

    return getAxiosInstance(retries).request<EnforcePspStatusResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayFormDataResponse> {
    let url = `/api/jpm/data`;

    return getAxiosInstance(retries).request<PayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param prepareCheckoutRequest   */
  prepareCheckout(
    prepareCheckoutRequest: PrepareCheckoutRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    let url = `/api/jpm/prepareCheckout`;

    return getAxiosInstance(retries).request<unknown>({
      url: url,
      method: 'POST',
      data: prepareCheckoutRequest,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) * @param checkoutId  (API name: CheckoutId) */
  verify(
    paymentId: string,
    checkoutId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<VerifyResponse> {
    let url = `/api/jpm/verify`;

    return getAxiosInstance(retries).request<VerifyResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
        CheckoutId: checkoutId,
      },
      ...$config,
    });
  },
};

export const octetPaymentClient = {
  /**
   * @param octetCreatePaymentRequest   */
  createPayment(
    octetCreatePaymentRequest: OctetCreatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<OctetCreatePaymentResponse> {
    let url = `/api/octet/createPayment`;

    return getAxiosInstance(retries).request<OctetCreatePaymentResponse>({
      url: url,
      method: 'POST',
      data: octetCreatePaymentRequest,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<OctetPayFormDataResponse> {
    let url = `/api/octet/data`;

    return getAxiosInstance(retries).request<OctetPayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param apiReferenceId   */
  verifyIsTransactionCancelled(
    apiReferenceId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<boolean> {
    let url = `/api/octet/verifyTransactionIsCancelled`;

    return getAxiosInstance(retries).request<boolean>({
      url: url,
      method: 'GET',
      params: {
        apiReferenceId: apiReferenceId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) * @param paymentMethodChangeNumber  (API name: PaymentMethodChangeNumber) */
  verifyTransactions(
    paymentId: string,
    paymentMethodChangeNumber: number,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<OctetVerifyTransactionsResponse> {
    let url = `/api/octet/verifyTransactions`;

    return getAxiosInstance(retries).request<OctetVerifyTransactionsResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
        PaymentMethodChangeNumber: paymentMethodChangeNumber,
      },
      ...$config,
    });
  },
};

export const octetV2PaymentPageClient = {
  /**
   * @param request   */
  enforceStatusCheck(
    request: PaymentIdRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EnforcePspStatusResult> {
    let url = `/api/octetv2/enforceStatusCheck`;

    return getAxiosInstance(retries).request<EnforcePspStatusResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<OctetV2FormDataResponse> {
    let url = `/api/octetv2/data`;

    return getAxiosInstance(retries).request<OctetV2FormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: OctetV2InitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<OctetV2InitiatePaymentResponse> {
    let url = `/api/octetv2/initiatePayment`;

    return getAxiosInstance(retries).request<OctetV2InitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  verifyTransaction(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<OctetV2VerifyTransactionResponse> {
    let url = `/api/octetv2/verifyTransaction`;

    return getAxiosInstance(retries).request<OctetV2VerifyTransactionResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },
};

export const payDollarPaymentPageClient = {
  /**
   * @param request   */
  enforcePspStatusCheck(
    request: PayDollarStatusCheckRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EnforcePspStatusResult> {
    let url = `/api/paydollar/enforceStatusCheck`;

    return getAxiosInstance(retries).request<EnforcePspStatusResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayFormDataPayDollar> {
    let url = `/api/paydollar/data`;

    return getAxiosInstance(retries).request<PayFormDataPayDollar>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },
};

export const payEaseClient = {
  /**
   * @param requestId   */
  checkTransactionStatus(
    requestId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<OrderStatusResponse> {
    let url = `/api/payease/status`;

    return getAxiosInstance(retries).request<OrderStatusResponse>({
      url: url,
      method: 'GET',
      params: {
        requestId: requestId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  enforceStatusCheck(
    request: PaymentIdRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EnforcePspStatusResult> {
    let url = `/api/payease/enforceStatusCheck`;

    return getAxiosInstance(retries).request<EnforcePspStatusResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayFormDataPayEase> {
    let url = `/api/payease/data`;

    return getAxiosInstance(retries).request<PayFormDataPayEase>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getPaymentSuccessData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayEasePaymentSuccessData> {
    let url = `/api/payease/paymentSuccess`;

    return getAxiosInstance(retries).request<PayEasePaymentSuccessData>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  sendPaymentRequest(
    request: OrderRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<OrderResponse> {
    let url = `/api/payease/paymentRequest`;

    return getAxiosInstance(retries).request<OrderResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

export const payEaseWebhookClient = {
  /**
   * @param response   * @param paymentId   * @param encryptKey   */
  receiveNotification(
    response: PayEaseEncodedResponse,
    paymentId: string,
    encryptKey: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<File> {
    let url = `/api/payease/webhook/notify`;

    return getAxiosInstance(retries).request<File>({
      url: url,
      method: 'POST',
      data: response,
      params: {
        paymentId: paymentId,
      },
      headers: {
        encryptKey: encryptKey,
      },
      ...$config,
    });
  },

  /**
   * @param response   * @param paymentId   * @param providerConfigurationCode   * @param encryptKey   */
  receiveNotificationV2(
    response: PayEaseEncodedResponse,
    paymentId: string,
    providerConfigurationCode: string,
    encryptKey: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<File> {
    let url = `/api/payease/webhook/v2/notify`;

    return getAxiosInstance(retries).request<File>({
      url: url,
      method: 'POST',
      data: response,
      params: {
        paymentId: paymentId,
        providerConfigurationCode: providerConfigurationCode,
      },
      headers: {
        encryptKey: encryptKey,
      },
      ...$config,
    });
  },
};

export const payPalPaymentPageClient = {
  /**
   * @param _data  (API name: data) */
  capturePaymentRequest(
    _data: PayPalCapturePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayPalCaptureStatus> {
    let url = `/api/paypal/captureOrder`;

    return getAxiosInstance(retries).request<PayPalCaptureStatus>({
      url: url,
      method: 'POST',
      data: _data,
      ...$config,
    });
  },

  /**
   * @param request   */
  createOrder(
    request: PaymentIdRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayPalOrderData> {
    let url = `/api/paypal/createOrder`;

    return getAxiosInstance(retries).request<PayPalOrderData>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayPalPayFormData> {
    let url = `/api/paypal/data`;

    return getAxiosInstance(retries).request<PayPalPayFormData>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getPaymentData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayPalOrderData> {
    let url = `/api/paypal/orderData`;

    return getAxiosInstance(retries).request<PayPalOrderData>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param orderId   */
  verifyIsTransactionCancelled(
    orderId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<boolean> {
    let url = `/api/paypal/verify`;

    return getAxiosInstance(retries).request<boolean>({
      url: url,
      method: 'GET',
      params: {
        orderId: orderId,
      },
      ...$config,
    });
  },
};

export const paymobPaymentPageClient = {
  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymobFormDataResponse> {
    let url = `/api/paymob/data`;

    return getAxiosInstance(retries).request<PaymobFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: PaymobInitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymobInitiatePaymentResponse> {
    let url = `/api/paymob/initiatePayment`;

    return getAxiosInstance(retries).request<PaymobInitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  verifyTransaction(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymobVerifyTransactionResponse> {
    let url = `/api/paymob/verifyTransaction`;

    return getAxiosInstance(retries).request<PaymobVerifyTransactionResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },
};

export const paystackPaymentPageClient = {
  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaystackPayFormDataResponse> {
    let url = `/api/paystack/data`;

    return getAxiosInstance(retries).request<PaystackPayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: PaystackInitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaystackInitiatePaymentResponse> {
    let url = `/api/paystack/initiatePayment`;

    return getAxiosInstance(retries).request<PaystackInitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  verifyTransaction(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaystackVerifyTransactionResponse> {
    let url = `/api/paystack/verifyTransaction`;

    return getAxiosInstance(retries).request<PaystackVerifyTransactionResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },
};

export const seerBitV2PaymentPageClient = {
  /**
   * @param paymentId   * @param transactionReferenceId   */
  checkPaymentStatus(
    paymentId: string,
    transactionReferenceId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<CheckSeerBitPaymentStatusResponse> {
    let url = `/api/seerBitV2/checkPaymentStatus`;

    return getAxiosInstance(retries).request<CheckSeerBitPaymentStatusResponse>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
        transactionReferenceId: transactionReferenceId,
      },
      ...$config,
    });
  },

  /**
   * @param _data  (API name: data) */
  finishPayment(
    _data: SeerBitFinishPaymentRequestData,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SeerBitFinishPaymentResponse> {
    let url = `/api/seerBitV2/finishPayment`;

    return getAxiosInstance(retries).request<SeerBitFinishPaymentResponse>({
      url: url,
      method: 'POST',
      data: _data,
      ...$config,
    });
  },

  /**
   * @param request   */
  initPayFormData(
    request: InitPayFormDataRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayFormDataSeerBit> {
    let url = `/api/seerBitV2/initData`;

    return getAxiosInstance(retries).request<PayFormDataSeerBit>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  saveSeerBitLog(
    request: SaveSeerBitLog,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    let url = `/api/seerBitV2/saveLog`;

    return getAxiosInstance(retries).request<unknown>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

export const sslCommerzPaymentClient = {
  /**
   * @param request   */
  finishPayment(
    request: SslCommerzFinishPaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SslCommerzFinishPaymentResponse> {
    let url = `/api/sslcommerz/finishPayment`;

    return getAxiosInstance(retries).request<SslCommerzFinishPaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId  (API name: PaymentId) */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SslCommerzPayFormDataResponse> {
    let url = `/api/sslcommerz/data`;

    return getAxiosInstance(retries).request<SslCommerzPayFormDataResponse>({
      url: url,
      method: 'GET',
      params: {
        PaymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  initiatePayment(
    request: SslCommerzInitiatePaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SslCommerzInitiatePaymentResponse> {
    let url = `/api/sslcommerz/initiatePayment`;

    return getAxiosInstance(retries).request<SslCommerzInitiatePaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

export const stripeInstalmentPlanClient = {
  /**
   * @param request   */
  addInstalmentPlanPayment(
    request: AddInstalmentPlanPaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<AddInstalmentPlanPaymentResponse> {
    let url = `/api/stripe/instalment-plan/addInstalmentPlanPayment`;

    return getAxiosInstance(retries).request<AddInstalmentPlanPaymentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  confirmPaymentMethod(
    request: ConfirmPaymentMethodRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<InstalmentPlanPaymentMethodResult> {
    let url = `/api/stripe/instalment-plan/confirmPaymentMethod`;

    return getAxiosInstance(retries).request<InstalmentPlanPaymentMethodResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param instalmentPlanId   */
  getFormData(
    instalmentPlanId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<GetInstalmentPlanFormDataStripeResponse> {
    let url = `/api/stripe/instalment-plan/getFormData`;

    return getAxiosInstance(retries).request<GetInstalmentPlanFormDataStripeResponse>({
      url: url,
      method: 'GET',
      params: {
        instalmentPlanId: instalmentPlanId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  startInstalmentPlan(
    request: StartInstalmentPlanRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<StartInstalmentPlanResponse> {
    let url = `/api/stripe/instalment-plan/start`;

    return getAxiosInstance(retries).request<StartInstalmentPlanResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  updatePaymentMethod(
    request: UpdateInstalmentPlanPaymentMethodRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<InstalmentPlanPaymentMethodResult> {
    let url = `/api/stripe/instalment-plan/updateInstalmentPlanPaymentMethod`;

    return getAxiosInstance(retries).request<InstalmentPlanPaymentMethodResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

export const stripePaymentClient = {
  /**
   * @param request   */
  confirmPayment(
    request: ConfirmPaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentIntentStatus> {
    let url = `/api/stripe/confirmPayment`;

    return getAxiosInstance(retries).request<PaymentIntentStatus>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  createMultibancoPayment(
    request: CreateMultibancoPaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    let url = `/api/stripe/createMultibancoPayment`;

    return getAxiosInstance(retries).request<unknown>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  createPaymentIntent(
    request: CreatePaymentIntentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentIntentStatus> {
    let url = `/api/stripe/createPaymentIntent`;

    return getAxiosInstance(retries).request<PaymentIntentStatus>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  enforceSourceInformationUpdate(
    request: PaymentSourceRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<EnforcePspStatusResult> {
    let url = `/api/stripe/enforceSourceInformationUpdateAsync`;

    return getAxiosInstance(retries).request<EnforcePspStatusResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getBankTransferInfo(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<BankTransferPaymentInfo> {
    let url = `/api/stripe/bankTransferData`;

    return getAxiosInstance(retries).request<BankTransferPaymentInfo>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getFPXPaymentInfo(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<FpxPaymentInfoData> {
    let url = `/api/stripe/fpxData`;

    return getAxiosInstance(retries).request<FpxPaymentInfoData>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  getIntentCallData(
    request: PaymentIntentCallDataRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentIntentCallData> {
    let url = `/api/stripe/getIntentCallDataAsync`;

    return getAxiosInstance(retries).request<PaymentIntentCallData>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getMultibancoPayment(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<MultibancoPaymentSourceResult> {
    let url = `/api/stripe/multibancoPayment`;

    return getAxiosInstance(retries).request<MultibancoPaymentSourceResult>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayFormDataPaymentStripe> {
    let url = `/api/stripe/data`;

    return getAxiosInstance(retries).request<PayFormDataPaymentStripe>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  getSourceCallData(
    request: PaymentSourceCallDataRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentSourceFrontendCallData> {
    let url = `/api/stripe/getSourceCallDataAsync`;

    return getAxiosInstance(retries).request<PaymentSourceFrontendCallData>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param paymentId   */
  getWeChatPayFormData(
    paymentId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PayFormDataPaymentWeChat> {
    let url = `/api/stripe/wechatData`;

    return getAxiosInstance(retries).request<PayFormDataPaymentWeChat>({
      url: url,
      method: 'GET',
      params: {
        paymentId: paymentId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  processPaymentIntent(
    request: ProcessPaymentIntentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentIntentStatus> {
    let url = `/api/stripe/processPaymentIntent`;

    return getAxiosInstance(retries).request<PaymentIntentStatus>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  submitKlarnaPaymentIntent(
    request: SubmitKlarnaPaymentIntentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubmitKlarnaPaymentIntentResponse> {
    let url = `/api/stripe/submitKlarnaPaymentIntent`;

    return getAxiosInstance(retries).request<SubmitKlarnaPaymentIntentResponse>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  submitPaymentIntent(
    request: SubmitPaymentIntentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<PaymentIntentStatus> {
    let url = `/api/stripe/submitPaymentIntent`;

    return getAxiosInstance(retries).request<PaymentIntentStatus>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

export const stripeSubscriptionClient = {
  /**
   * @param request   */
  confirmPaymentMethod(
    request: ConfirmPaymentMethodUpdateRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionChangeResult> {
    let url = `/api/stripe/confirmPaymentMethod`;

    return getAxiosInstance(retries).request<SubscriptionChangeResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  confirmRequiredActionCompleted(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionChangeResult> {
    let url = `/api/stripe/confirmRequiredActionCompleted`;

    return getAxiosInstance(retries).request<SubscriptionChangeResult>({
      url: url,
      method: 'POST',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  confirmSubscriptionPayment(
    request: ConfirmSubscriptionPaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionChangeResult> {
    let url = `/api/stripe/confirmSubscriptionPayment`;

    return getAxiosInstance(retries).request<SubscriptionChangeResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  createSubscriptionCustomer(
    request: CreateSubscriptionCustomerRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<CreateSubscriptionCustomerResult> {
    let url = `/api/stripe/createCustomer`;

    return getAxiosInstance(retries).request<CreateSubscriptionCustomerResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param subscriptionId   */
  getSubscriptionFormData(
    subscriptionId: string,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionFormDataStripe> {
    let url = `/api/stripe/getSubscriptionFormData`;

    return getAxiosInstance(retries).request<SubscriptionFormDataStripe>({
      url: url,
      method: 'GET',
      params: {
        subscriptionId: subscriptionId,
      },
      ...$config,
    });
  },

  /**
   * @param request   */
  retrySubscriptionPayment(
    request: RetrySubscriptionPaymentRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionChangeResult> {
    let url = `/api/stripe/retrySubscriptionPayment`;

    return getAxiosInstance(retries).request<SubscriptionChangeResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  startSubscription(
    request: StartSubscriptionRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionChangeResult> {
    let url = `/api/stripe/startSubscription`;

    return getAxiosInstance(retries).request<SubscriptionChangeResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },

  /**
   * @param request   */
  startUpdatePaymentMethod(
    request: StartUpdatePaymentMethodRequest,
    retries: Make = Make.NoRetry,
    $config?: AxiosRequestConfig
  ): AxiosPromise<SubscriptionChangeResult> {
    let url = `/api/stripe/startUpdatePaymentMethod`;

    return getAxiosInstance(retries).request<SubscriptionChangeResult>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
};

/**
 * Serializes a params object into a query string that is compatible with different REST APIs.
 * Implementation from: https://github.com/suhaotian/xior/blob/main/src/utils.ts
 * Kudos to @suhaotian for the original implementation
 */
function encodeParams<T = any>(
  params: T,
  parentKey: string | null = null,
  options?: {
    allowDots?: boolean;
    serializeDate?: (value: Date) => string;
    arrayFormat?: 'indices' | 'repeat' | 'brackets';
  }
): string {
  if (params === undefined || params === null) return '';
  const encodedParams: string[] = [];
  const paramsIsArray = Array.isArray(params);
  const { arrayFormat, allowDots, serializeDate } = options || {};

  const getKey = (key: string) => {
    if (allowDots && !paramsIsArray) return `.${key}`;
    if (paramsIsArray) {
      if (arrayFormat === 'brackets') {
        return '[]';
      }
      if (arrayFormat === 'repeat') {
        return '';
      }
    }
    return `[${key}]`;
  };

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      let value = (params as any)[key];
      if (value !== undefined) {
        const encodedKey = parentKey ? `${parentKey}${getKey(key)}` : (key as string);

        // biome-ignore lint/suspicious/noGlobalIsNan: <explanation>
        if (!isNaN(value) && value instanceof Date) {
          value = serializeDate ? serializeDate(value) : value.toISOString();
        }
        if (typeof value === 'object') {
          // If the value is an object or array, recursively encode its contents
          const result = encodeParams(value, encodedKey, options);
          if (result !== '') encodedParams.push(result);
        } else {
          // Otherwise, encode the key-value pair
          encodedParams.push(`${encodeURIComponent(encodedKey)}=${encodeURIComponent(value)}`);
        }
      }
    }
  }

  return encodedParams.join('&');
}
export interface IGoogleAnalyticsSettings {
  gtmCode: string;
  gaCode: string;
}

export interface CountryWithCode {
  isoCode: string;
  name: string;
}

export interface PayFormDataAdyen {
  isFinished?: boolean;
  correlationId: string;
  formattedAmount: string;
  clientKey: string;
  environment: string;
  adyenSessionData: string;
  adyenSessionId: string;
  paymentMethodType: string;
  payerAddress: AdyenPayerAddress;
  email: string;
  reference: string;
}

export interface AdyenPayerAddress {
  postalAddress?: string;
  postalCode?: string;
  town?: string;
  state?: string;
  country?: string;
}

export interface CheckRedirectResultResponse {
  isFinished?: boolean;
  isSuccessful?: boolean;
}

export interface AlePayInitiatePaymentResponse {
  checkoutUrl: string;
  isFinished: boolean;
}

export interface AlePayInitiatePaymentRequest {
  paymentId: string;
  buyerAddress: string;
  buyerCity: string;
  buyerCountry: string;
  buyerEmail: string;
  buyerName: string;
  buyerPhone: string;
}

export interface AlePayPayFormDataResponse {
  isFinished?: boolean;
  amount: number;
  currency: string;
  buyerAddress: string;
  buyerCity: string;
  buyerCountry: string;
  buyerEmail: string;
  buyerName: string;
  buyerPhone: string;
  correlationId: string;
}

export interface AlePayFinishPaymentResponse {
  status: AlePayPaymentStatus;
  isPaymentSuccessful?: boolean;
}

/**
 * 0 = Fail
 * 1 = Success
 */
export enum AlePayPaymentStatus {
  Fail = 0,
  Success = 1,
}

export interface AlePayFinishPaymentRequest {
  paymentId: string;
  transactionId: string;
}

export interface ErrorPageInstalmentPlanInfo {
  instalmentPlanId: InstalmentPlanId;
  correlationId: string;
  isFirstPaymentClosed: boolean;
  redirectUrl?: string;
  startUrl?: string;
}

export interface InstalmentPlanId {
  value?: string;
}

export interface SupportContactInformationRecord {
  supportContactInformation?: string;
  correlationId?: string;
}

export interface InstalmentPlanConfigurationResult {
  instalmentPlanId: string;
  providerPaymentMethodGroupCode: string;
  customizationData?: CustomizationData;
  timeoutValue: number;
  collectBillingDetails?: boolean;
  correlationSessionId?: string;
  additionalSettings?: AdditionalSettings;
  isTranslationAllowed?: boolean;
}

export interface CustomizationData {
  accessibilityUrl?: string;
  dataProtectionUrl?: string;
  paymentPageLogoImageUrl?: string;
  privacyAndCookiesUrl?: string;
  termsOfUseUrl?: string;
  copyrightOwner?: string;
  defaultLanguageCode?: string;
  languageList?: string[];
}

export interface AdditionalSettings {
  isSalesForceChatEnabled?: boolean;
  salesForceChatDeploymentId?: string;
  salesForceChatOrganisationId?: string;
  salesForceApiEndpointId?: string;
  salesForceChatUserId?: string;
}

/**
 * Structure used to pass all exceptions that happen on NPP side.
 * Outside message can be shown in Client Application UI.
 * Inner exception is to be securely stored for further investigation in Client Application logs.
 */
export interface ApiErrorResponse {
  /** Human readable message structure. */
  message: string;
  /** Additional error identifier */
  additionalIdentifier?: string;
  /** Root cause exception describing technical details of the problem. This message SHOULD NOT be visible to user in UI. */
  innerException: ApiError;
}

/** Api error structure. */
export interface ApiError {
  /** Detailed class of exception that uniquely identifies problem root cause. This information SHOULD NOT be visible to user in UI. */
  class: string;
  /** Human readable exception message. This message SHOULD NOT be visible to user in UI. */
  message: string;
  /**
   * Exception group information that identifies system that cause exception.
   * This can be: NPP, integrated Payment Service Provider or Client Application.
   * This information SHOULD NOT be visible to user in UI.
   */
  group: ApiErrorGroup;
}

/**
 * Possible exception group values.
 *
 * 0 = ApiException
 * 1 = NppException
 * 2 = ClientAppException
 * 3 = PaymentProviderException
 * 4 = SubscriptionProviderException
 */
export enum ApiErrorGroup {
  ApiException = 0,
  NppException = 1,
  ClientAppException = 2,
  PaymentProviderException = 3,
  SubscriptionProviderException = 4,
}

export interface InstalmentPlanStatusData {
  isFirstPaymentClosed: boolean;
  redirectUrl: string;
  correlationId: string;
  instalmentPlanStatus: InstalmentPlanStatus;
  instalmentPlanId: string;
  currencyCode: string;
  sumAmount: number;
  sumAmountFormatted: string;
  dueAmount: number;
  dueAmountFormatted: string;
  sumAmountFormattedWithCurrency: string;
  dueAmountFormattedWithCurrency: string;
  instalments: InstalmentForStatusData[];
  lineItems: LineItemForStatusData[];
  statusUrl: string;
}

/**
 * 0 = Initial
 * 1 = Inactive
 * 2 = Active
 * 4 = Cancelled
 * 5 = Completed
 */
export enum InstalmentPlanStatus {
  Initial = 0,
  Inactive = 1,
  Active = 2,
  Cancelled = 4,
  Completed = 5,
}

export interface InstalmentForStatusData {
  instalmentId: string;
  dueDate: Date;
  currencyCode: string;
  amount: number;
  amountFormatted: string;
  amountFormattedWithCurrency: string;
  instalmentStatus: InstalmentStatus;
  paymentDescription?: string;
}

/**
 * 0 = Initial
 * 1 = Pending
 * 2 = Due
 * 3 = Cancelled
 * 4 = Paid
 */
export enum InstalmentStatus {
  Initial = 0,
  Pending = 1,
  Due = 2,
  Cancelled = 3,
  Paid = 4,
}

export interface LineItemForStatusData {
  amount: number;
  amountFormatted: string;
  currencyCode: string;
  amountFormattedWithCurrency: string;
  productDescription?: string;
}

export interface InstalmentPlanPaymentUpdateData {
  instalmentPlanId: string;
  timeoutValue: number;
  failureRedirectUrl: string;
}

export interface GenerateInstalmentPlanUpdatePaymentMethodUrlResponse {
  url: string;
}

export interface GenerateInstalmentPlanUpdatePaymentMethodUrlRequest {
  instalmentPlanId: string;
}

export interface PaymentInformation {
  amount: string;
  operationCode: string;
  correlationId: string;
  countryCode: string;
  currency: string;
  providerConfigurationCode: string;
  paymentMethodGroup: string;
  paymentId: string;
}

export interface PaymentStatusData {
  isFinished?: boolean;
  redirectUrl: string;
  isSuccessful: boolean;
  correlationId: string;
  startUrl?: string;
  productsSummary: PaymentProductsSummaryData;
  providerPaymentMethodGroupCode?: string;
  providerCode?: string;
}

export interface PaymentProductsSummaryData {
  amount: number;
  currencyCode: string;
  amountFormattedWithCurrency: string;
  lineItems: PaymentProductsSummaryItem[];
}

export interface PaymentProductsSummaryItem {
  description: string;
  amountFormatted: string;
  amountFormattedWithCurrency: string;
}

export interface PaymentConfigurationResult {
  paymentId: string;
  customizationData?: CustomizationData;
  timeoutValue: number;
  collectBillingDetails?: boolean;
  correlationSessionId?: string;
  additionalSettings?: AdditionalSettings;
  isTranslationAllowed?: boolean;
  providerPaymentMethodGroupCode: string;
  applicationCode: string;
  abExperimentAssignments?: AbExperimentAssignment[];
  activeAbExperiments?: ActiveAbExperiment[];
}

export interface AbExperimentAssignment {
  experimentId?: number;
  experimentName?: string;
  experimentEndTime?: Date;
  assignedVariantCode?: string;
  availableVariants?: AbVariantOption[];
}

export interface AbVariantOption {
  variantCode?: string;
  description?: string;
  provider?: string;
  hardStop?: boolean;
}

export interface ActiveAbExperiment {
  experimentId?: number;
  experimentName?: string;
  experimentEndTime?: Date;
  availableVariants?: AbVariantOption[];
}

export interface ErrorPagePaymentInfo {
  paymentId: string;
  correlationId: string;
  isPaymentFinished: boolean;
  redirectUrl?: string;
  startUrl?: string;
  amountFormatted?: string;
}

export interface StatusPagePaymentInfo {
  paymentId: string;
  correlationId: string;
  amountFormattedWithCurrency: string;
  paymentStatus: PaymentStatus;
  redirectUrl?: string;
  paymentUrl?: string;
  productsSummary: PaymentProductsSummaryData;
  providerPaymentMethodGroupCode?: string;
  providerCode?: string;
}

/**
 * 0 = Initial
 * 1 = Initialized
 * 2 = Ready
 * 3 = Started
 * 4 = Charged
 * 5 = Failed
 * 6 = Suspended
 * 7 = Refunded
 * 9 = FailedAtStart
 * 10 = PartiallyRefunded
 * 11 = Pending
 * 12 = PartiallyFunded
 */
export enum PaymentStatus {
  Initial = 0,
  Initialized = 1,
  Ready = 2,
  Started = 3,
  Charged = 4,
  Failed = 5,
  Suspended = 6,
  Refunded = 7,
  FailedAtStart = 9,
  PartiallyRefunded = 10,
  Pending = 11,
  PartiallyFunded = 12,
}

export interface ActiveConfigurationResult {
  configurationId: number;
  providerPaymentMethodGroupId: number;
  name: string;
  shortCode: string;
  providerCode: string;
  order?: number;
  badgeCode?: string;
}

export interface ChoosePaymentMethodResult {
  redirectUrl: string;
  paymentUrl?: string;
  paymentId: string;
  ifNextChangeIsPossible: boolean;
  isPaymentFinished: boolean;
}

export interface ChoosePaymentMethodRequest {
  paymentId?: string;
  providerPaymentMethodGroupId?: number;
}

export interface SubscriptionStatusResponse {
  subscriptionStatus?: SubscriptionStatus;
  redirectUrl?: string;
}

/**
 * 0 = Initial
 * 1 = Initialized
 * 2 = Ready
 * 3 = CreatedInPsp
 * 4 = Trialing
 * 5 = Active
 * 6 = PastDue
 * 7 = FailedAtStart
 * 8 = Cancelled
 */
export enum SubscriptionStatus {
  Initial = 0,
  Initialized = 1,
  Ready = 2,
  CreatedInPsp = 3,
  Trialing = 4,
  Active = 5,
  PastDue = 6,
  FailedAtStart = 7,
  Cancelled = 8,
}

export interface SubscriptionStatusData {
  isFirstPaymentClosed?: boolean;
  redirectUrl: string;
  correlationId: string;
  productsSummary: SubscriptionProductsSummaryData;
  discount?: SubscriptionDiscountData;
}

export interface SubscriptionProductsSummaryData {
  amount?: number;
  planPricingIntervalUnit?: string;
  planTrialIntervalCount: number;
  planTrialIntervalUnit?: string;
  planPricingIntervalCount: number;
  planProductDescription?: string;
  amountFormattedWithCurrency?: string;
}

export interface SubscriptionDiscountData {
  discountAmountFormattedWithCurrency?: string;
  discountedAmountFormattedWithCurrency?: string;
  discountDetails?: Discount;
}

export interface Discount {
  discountId?: DiscountId;
  id?: string;
  name?: string;
  percentOff?: number;
  amountOff?: number;
  durationInPeriods?: number;
  startTime?: Date;
  expiryTime?: Date;
  type?: DiscountType;
  manualDeactivationDate?: Date;
}

export interface DiscountId {
  value?: string;
}

/**
 * 0 = PercentOff
 * 1 = AmountOff
 */
export enum DiscountType {
  PercentOff = 0,
  AmountOff = 1,
}

export interface SubscriptionConfigurationResult {
  subscriptionId: string;
  providerPaymentMethodGroupCode: string;
  customizationData?: CustomizationData;
  timeoutValue: number;
  collectBillingDetails?: boolean;
  correlationSessionId?: string;
  additionalSettings?: AdditionalSettings;
  isTranslationAllowed?: boolean;
  hasTrial?: boolean;
}

export interface SubscriptionPaymentUpdateData {
  subscriptionId: string;
  timeoutValue: number;
  failureRedirectUrl: string;
}

export interface ErrorPageSubscriptionInfo {
  subscriptionId: string;
  correlationId: string;
  isFirstPaymentClosed: boolean;
  redirectUrl?: string;
  startUrl?: string;
}

export interface CyberSourcePayFormDataResponse {
  isFinished?: boolean;
  correlationId: string;
  firstName?: string;
  surname?: string;
  email?: string;
  amountFormatted: string;
  payerAddress?: CyberSourcePayerAddress;
  countryCodesWithRequiredStateField: string[];
}

export interface CyberSourcePayerAddress {
  postalAddress?: string;
  postalCode?: string;
  town?: string;
  state?: string;
  country?: string;
}

export interface CyberSourceStartPaymentResponse {
  accessKey?: string;
  profileId?: string;
  signedFieldNames?: string;
  signature?: string;
  transactionType?: string;
  referenceNumber?: string;
  amount?: string;
  currency?: string;
  billToAddressCity?: string;
  billToAddressCountry?: string;
  billToAddressLine1?: string;
  billToEmail?: string;
  billToForename?: string;
  billToAddressPostalCode?: string;
  billToAddressState?: string;
  billToSurname?: string;
  customerIpAddress?: string;
  customerBrowserScreenHeight?: number;
  customerBrowserScreenWidth?: number;
  locale?: string;
  signedDateTime?: string;
  transactionUuid?: string;
  cyberSourceUrl?: string;
  overrideCustomReceiptPage?: string;
  overrideCustomCancelPage?: string;
  isFinished?: boolean;
  overrideBackofficePostUrl?: string;
}

export interface CyberSourceStartPaymentRequest {
  paymentId: string;
  firstName: string;
  surname: string;
  email: string;
  locale: string;
  postalAddress: string;
  postalCode: string;
  town: string;
  state?: string;
  country: string;
  customerIpAddress?: string;
  customerBrowserScreenHeight?: number;
  customerBrowserScreenWidth?: number;
}

export interface DokuV2FormDataResponse {
  isFinished?: boolean;
  firstName: string;
  lastName: string;
  amount: string;
  currency: string;
  email?: string;
}

export interface DokuV2InitiatePaymentResponse {
  redirectUrl: string;
  isPaymentFinished?: boolean;
}

export interface DokuV2InitiatePaymentRequest {
  paymentId: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface DokuV2VerifyTransactionResponse {
  status?: DokuV2TransactionStatus;
}

/**
 * 10 = Pending
 * 20 = Successful
 * 30 = Failed
 */
export enum DokuV2TransactionStatus {
  Pending = 10,
  Successful = 20,
  Failed = 30,
}

export interface DragonPayPayFormDataResponse {
  isFinished?: boolean;
  email?: string;
  amountFormatted: string;
  correlationId: string;
  redirectUrl?: string;
}

export interface DragonPayInitiatePaymentResponse {
  redirectUrl: string;
  isPaymentFinished?: boolean;
}

export interface DragonPayInitiatePaymentRequest {
  paymentId: string;
  email: string;
}

export interface EnforcePspStatusResult {
  enforcePspAllowed?: boolean;
  paymentHasFinalStatus?: boolean;
  paymentSuccessful?: boolean;
  paymentStatus?: string;
  attemptFailedAtPsp?: boolean;
}

/** Basic request with PaymentId */
export interface PaymentIdRequest {
  /** Payment Id */
  paymentId: string;
}

export interface DragonPayVerifyTransactionResponse {
  isPending?: boolean;
  isSuccessful?: boolean;
}

export interface PayFormDataEsewa {
  isFinished?: boolean;
  productId: string;
  amount: number;
  paymentUrl: string;
  merchantCode: string;
  signedFieldNames: string;
  signature: string;
  productCode: string;
  successUrl: string;
  failureUrl: string;
}

export interface EsewaVerifyTransactionResponse {
  status?: EsewaTransactionStatus;
  version?: number;
}

/**
 * 10 = Pending
 * 20 = Successful
 * 30 = Failed
 */
export enum EsewaTransactionStatus {
  Pending = 10,
  Successful = 20,
  Failed = 30,
}

export interface FiuuPayFormDataResponse {
  isFinished?: boolean;
  paymentScriptUrl: string;
  webhookUrl: string;
  returnUrl: string;
  name: string;
  email: string;
  merchantId: string;
  correlationId: string;
  fiuuOrderId: string;
  amount: string;
  currency: string;
  vCode: string;
}

export interface FiuuChannelsResponse {
  channels?: FiuuChannel[];
}

export interface FiuuChannel {
  id?: string;
  name?: string;
}

export interface FiuuInitiatePaymentResponse {
  isPaymentFinished?: boolean;
}

export interface FiuuInitiatePaymentRequest {
  paymentId: string;
  billEmail: string;
  billName: string;
  billMobile: string;
  billDescription: string;
  orderId: string;
  channel: string;
}

export interface FlutterwavePayFormDataResponse {
  isFinished?: boolean;
  correlationId: string;
  amountFormatted: string;
  currencyCode: string;
  email: string;
}

export interface FlutterwaveInitiatePaymentResponse {
  gatewayPageUrl: string;
  isFinished: boolean;
  isNqrPayment?: boolean;
  qrCode?: string;
}

export interface FlutterwaveInitiatePaymentRequest {
  paymentId: string;
  email: string;
  correlationId: string;
}

export interface FlutterwaveVerifyTransactionResponse {
  status?: FlutterwaveTransactionStatus;
}

/**
 * 10 = Pending
 * 20 = Successful
 * 30 = Failed
 */
export enum FlutterwaveTransactionStatus {
  Pending = 10,
  Successful = 20,
  Failed = 30,
}

export interface PayFormDataResponse {
  isFinished?: boolean;
  jpmScriptUrl: string;
  redirectUrl: string;
  email: string;
  countryCode: string;
  state: string;
  city: string;
  postcode: string;
  street: string;
  amountFormatted: string;
  correlationId: string;
  checkoutId: string;
}

export interface PrepareCheckoutRequest {
  paymentId: string;
  email: string;
}

export interface VerifyResponse {
  isPaymentFinished: boolean;
  isCheckoutIdActive: boolean;
  isCancelled: boolean;
}

export interface CheckPaymentStatusRequest {
  paymentId: string;
  checkoutId: string;
}

export interface OctetPayFormDataResponse {
  isFinished?: boolean;
  correlationId: string;
  amountFormatted: string;
  name: string;
  surname: string;
  email: string;
  mobilePhone: string;
  mobilePhoneAreaCode: string;
  commonPaymentPageUrl: string;
  apiReferenceId: string;
}

export interface OctetCreatePaymentResponse {
  commonPaymentPageUrl: string;
  apiReferenceId: string;
}

export interface OctetCreatePaymentRequest {
  paymentId: string;
  name: string;
  surname: string;
  email: string;
  mobilePhone: string;
  mobilePhoneAreaCode: string;
}

export interface OctetVerifyTransactionsResponse {
  isPending?: boolean;
  isSuccessful?: boolean;
}

export interface OctetV2FormDataResponse {
  isFinished?: boolean;
  firstName: string;
  lastName: string;
  amount: string;
  currency: string;
  email?: string;
  countries?: OctetV2CountryResponse[];
}

export interface OctetV2CountryResponse {
  name: string;
  code: string;
  phoneCode: string;
  phoneMaskFormat: string;
  flagUrl: string;
}

export interface OctetV2InitiatePaymentResponse {
  redirectUrl: string;
  isPaymentFinished?: boolean;
}

export interface OctetV2InitiatePaymentRequest {
  paymentId: string;
  firstName: string;
  lastName: string;
  email?: string;
  phoneCode?: string;
  phoneNumber?: string;
  languageCode?: string;
}

export interface OctetV2VerifyTransactionResponse {
  status?: OctetV2TransactionStatus;
}

/**
 * 10 = Pending
 * 20 = Successful
 * 30 = Failed
 */
export enum OctetV2TransactionStatus {
  Pending = 10,
  Successful = 20,
  Failed = 30,
}

export interface PayFormDataPayDollar {
  isFinished?: boolean;
  remark?: string;
  orderReference?: string;
  amount?: string;
  currencyCode?: string;
  finishUrl?: string;
  paymentType?: string;
  merchantId?: string;
  paymentUrl?: string;
  lang?: string;
  mpsMode?: string;
  paymentMethod?: string;
  secureHash?: string;
  autoRedirectInSeconds?: number;
}

export interface PayDollarStatusCheckRequest {
  paymentId: string;
}

export interface OrderStatusResponse {
  isCancelled?: boolean;
}

export interface PayFormDataPayEase {
  isFinished?: boolean;
  correlationId: string;
  amountFormatted: string;
  scanCode?: string;
  requestId?: string;
}

export interface OrderResponse {
  qrImageBase64?: string;
  requestId?: string;
  isGenerating: boolean;
}

export interface OrderErrorResponse {
  code?: TranslatedPayEaseErrorCode;
}

/**
 * 10 = PhoneIncorrect
 * 20 = NameIncorrect
 * 30 = IdIncorrect
 * 110 = DayLimitExceeded
 * 120 = SinglePaymentLimitExceeded
 * 130 = Timeout
 * 140 = ServiceUnavailable
 */
export enum TranslatedPayEaseErrorCode {
  PhoneIncorrect = 10,
  NameIncorrect = 20,
  IdIncorrect = 30,
  DayLimitExceeded = 110,
  SinglePaymentLimitExceeded = 120,
  Timeout = 130,
  ServiceUnavailable = 140,
}

export interface OrderRequest {
  paymentId: string;
  clientIp?: string;
}

export interface PayEasePaymentSuccessData {
  redirectUrl: string;
  correlationId: string;
}

export interface PayEaseEncodedResponse {
  data?: string;
}

export interface PayPalPayFormData {
  isFinished?: boolean;
  amount: string;
  currency: string;
  clientId: string;
  correlationId: string;
}

export interface PayPalOrderData {
  orderId?: string;
}

export interface PayPalCaptureStatus {
  isSuccessful?: boolean;
  finishPaymentUrl?: string;
}

export interface PayPalCapturePaymentRequest {
  paymentId: string;
  payPalOrderId: string;
}

export interface PaymobFormDataResponse {
  isFinished?: boolean;
  firstName: string;
  lastName: string;
  email: string;
  street: string;
  city: string;
  state: string;
  country: string;
  amount: string;
  currency: string;
}

export interface PaymobInitiatePaymentResponse {
  redirectUrl: string;
  isPaymentFinished?: boolean;
}

export interface PaymobInitiatePaymentRequest {
  paymentId: string;
  firstName: string;
  lastName: string;
  email: string;
  street: string;
  city: string;
  state: string;
  country: string;
  mobile: string;
}

export interface PaymobVerifyTransactionResponse {
  status?: PaymobTransactionStatus;
}

/**
 * 10 = Pending
 * 20 = Successful
 * 30 = Failed
 */
export enum PaymobTransactionStatus {
  Pending = 10,
  Successful = 20,
  Failed = 30,
}

export interface PaystackPayFormDataResponse {
  isFinished?: boolean;
  correlationId: string;
  amountFormatted: string;
  currencyCode: string;
  email: string;
}

export interface PaystackInitiatePaymentResponse {
  gatewayPageUrl: string;
  isFinished: boolean;
}

export interface PaystackInitiatePaymentRequest {
  paymentId: string;
  email: string;
}

export interface PaystackVerifyTransactionResponse {
  status?: PaystackTransactionStatus;
}

/**
 * 10 = Pending
 * 20 = Success
 * 30 = Failed
 * 40 = Abandoned
 * 50 = Reversed
 * 60 = Ongoing
 * 70 = Processing
 * 80 = Queued
 * 90 = Timeout
 */
export enum PaystackTransactionStatus {
  Pending = 10,
  Success = 20,
  Failed = 30,
  Abandoned = 40,
  Reversed = 50,
  Ongoing = 60,
  Processing = 70,
  Queued = 80,
  Timeout = 90,
}

export interface PayFormDataSeerBit {
  isFinished?: boolean;
  transactionReferenceId: string;
  currency: string;
  correlationId: string;
  country: string;
  amount: string;
  publicKey: string;
  paymentId: string;
  scriptUrl: string;
}

export interface InitPayFormDataRequest {
  paymentId: string;
}

export interface CheckSeerBitPaymentStatusResponse {
  isPaymentFinished?: boolean;
  isTransactionCancelled?: boolean;
}

export interface SeerBitFinishPaymentResponse {
  result?: FinishPaymentResult;
}

export interface FinishPaymentResult {
  isPaymentSuccessful?: boolean;
  seerBitPaymentStatus?: SeerBitPaymentStatus;
}

/**
 * 0 = Success
 * 1 = Pending
 * 2 = Other
 */
export enum SeerBitPaymentStatus {
  Success = 0,
  Pending = 1,
  Other = 2,
}

export interface SeerBitFinishPaymentRequestData {
  transRefId: string;
  paymentId: string;
}

export interface SaveSeerBitLog {
  paymentId: string;
  transRefId: string;
  data: SeerBitCallbackLog;
}

export interface SeerBitCallbackLog {
  code?: string;
  message?: string;
}

export interface SslCommerzPayFormDataResponse {
  isFinished?: boolean;
  name: string;
  email: string;
  amount: number;
  currency: string;
  postalAddress: string;
  postalCode: string;
  town: string;
  state?: string;
  country: string;
  phone: string;
  correlationId: string;
  gatewayPageUrl: string;
}

export interface SslCommerzInitiatePaymentResponse {
  gatewayPageUrl: string;
  isFinished: boolean;
}

export interface SslCommerzInitiatePaymentRequest {
  paymentId: string;
  name: string;
  email: string;
  postalAddress: string;
  postalCode: string;
  town: string;
  state?: string;
  country: string;
  phone: string;
}

export interface SslCommerzFinishPaymentResponse {
  isPaymentSuccessful: boolean;
  paymentStatus?: SslCommerzPaymentStatus;
}

/**
 * 0 = Success
 * 1 = Pending
 * 2 = Other
 */
export enum SslCommerzPaymentStatus {
  Success = 0,
  Pending = 1,
  Other = 2,
}

export interface SslCommerzFinishPaymentRequest {
  paymentId: string;
  status: string;
  transactionId: string;
}

export interface GetInstalmentPlanFormDataStripeResponse {
  isFinished?: boolean;
  stripePublicKey: string;
  accountCountry: string;
  transaction: StripeInstalmentPlanFormData;
  instalmentPlanInformation: InstalmentPlanInformation;
  instalments: StripeInstalmentFormData[];
  lineItems: StripeInstalmentPlanLineItemFormData[];
  currentPaymentMethod?: PaymentMethod;
}

export interface StripeInstalmentPlanFormData {
  firstInstalmentStripeAmount: number;
  instalmentPlanId?: string;
  currencyCode?: string;
  currencyDecimals?: number;
  firstInstalmentAmount: number;
  firstInstalmentAmountFormatted?: string;
  firstInstalmentAmountFormattedWithCurrency?: string;
  countryCode?: string;
  correlationId?: string;
  payer?: PayFormPayer;
  status: InstalmentPlanStatus;
  providerPaymentMethodGroupCode?: string;
  payerId?: string;
  providerCode?: string;
  instalments: StripeInstalmentFormData[];
  lineItems: StripeInstalmentPlanLineItemFormData[];
}

export interface PayFormPayer {
  firstName: string;
  surname: string;
  email?: string;
  postalAddress: string;
  postalCode: string;
  town: string;
  state: string;
  country: string;
}

export interface StripeInstalmentFormData {
  instalmentId?: string;
  dueDate: Date;
  amount: number;
  paymentDescription?: string;
  amountFormatted?: string;
  currencyCode?: string;
  amountFormattedWithCurrency?: string;
  instalmentStatus: InstalmentStatus;
}

export interface StripeInstalmentPlanLineItemFormData {
  productDescription?: string;
  amount: number;
  amountFormatted?: string;
  currencyCode?: string;
  amountFormattedWithCurrency?: string;
}

export interface InstalmentPlanInformation {
  operationCode: string;
  correlationId: string;
  countryCode: string;
  currency: string;
  providerConfigurationCode: string;
  paymentMethodGroup: string;
  instalmentPlanId: string;
  sumAmount: number;
  sumAmountFormatted: string;
  sumAmountFormattedWithCurrency: string;
}

export interface PaymentMethod {
  paymentMethodId: string;
  cardLast4: string;
}

export interface StartInstalmentPlanResponse {
  instalmentPlanId?: string;
  firstInstalmentId?: string;
  redirectUrl?: string;
  statusUrl?: string;
  paymentIntentClientSecret?: string;
}

export interface StartInstalmentPlanRequest {
  instalmentPlanId: string;
  paymentMethodId: string;
  instalmentPlanPayerAddress?: StripePayerAddress;
}

export interface StripePayerAddress {
  postalAddress: string;
  postalCode: string;
  town: string;
  state?: string;
  country: string;
}

export interface AddInstalmentPlanPaymentResponse {
  instalmentPlanId?: InstalmentPlanId;
  instalmentId?: InstalmentId;
  instalmentStatus?: InstalmentStatus;
  instalmentPlanStatus?: InstalmentPlanStatus;
  isFirstPaymentClosed?: boolean;
  paymentError?: StripeErrorCodeMapperResult;
}

export interface InstalmentId {
  value?: string;
}

export interface StripeErrorCodeMapperResult {
  message?: string;
  code?: string;
}

export interface AddInstalmentPlanPaymentRequest {
  instalmentPlanId: string;
  instalmentId: string;
}

export interface InstalmentPlanPaymentMethodResult {
  isSuccessful?: boolean;
  clientSecret?: string;
  redirectUrl?: string;
  isSetupIntent?: boolean;
}

export interface UpdateInstalmentPlanPaymentMethodRequest {
  instalmentPlanId: string;
  token: string;
  stripePayerAddress?: StripePayerAddress;
  paymentMethodId: string;
}

export interface ConfirmPaymentMethodRequest {
  instalmentPlanId: string;
  paymentMethodId: string;
  token: string;
}

export interface PaymentSourceFrontendCallData {
  sourceId: string;
  clientId: string;
  clientSecret: string;
}

export interface PaymentSourceCallDataRequest {
  paymentId: string;
}

export interface PaymentIntentCallData {
  clientId: string;
  clientSecret: string;
}

export interface PaymentIntentCallDataRequest {
  paymentId: string;
  paymentIntentId: string;
}

export interface PaymentSourceRequest {
  paymentId: string;
  sourceId: string;
}

export interface PaymentIntentStatus {
  isSuccessful?: boolean;
  requiresAction?: boolean;
  paymentAlreadyFinished?: boolean;
  paymentSuccessful?: boolean;
  clientUrl?: string;
  clientSecret?: string;
  message?: string;
  paymentIntentId?: string;
  stripeErrorCode?: string;
  redirectUrl?: string;
  qrCode?: string;
}

export interface CreatePaymentIntentRequest {
  paymentId: string;
  paymentMethodId: string;
  paymentOption: string;
  transactionPayer?: TransactionPayer;
  instalmentsCount?: number;
}

export interface TransactionPayer {
  fullName?: string;
  email?: string;
  postalAddress?: string;
  postalCode?: string;
  town?: string;
  state?: string;
  country?: string;
  countryCode?: string;
}

export interface SubmitPaymentIntentRequest {
  paymentId: string;
  payerEmail?: string;
  payerName?: string;
  payerBank?: string;
  code?: string;
  vpa?: string;
}

export interface SubmitKlarnaPaymentIntentResponse {
  redirectUrl?: string;
}

export interface SubmitKlarnaPaymentIntentRequest {
  paymentId: string;
  email?: string;
}

export interface ProcessPaymentIntentRequest {
  paymentId: string;
  paymentIntentId: string;
}

export interface ConfirmPaymentRequest {
  paymentId: string;
  paymentIntentId: string;
}

export interface PayFormDataPaymentStripe {
  isFinished?: boolean;
  stripePublicKey: string;
  accountCountry: string;
  transaction: PayFormPaymentStripe;
}

export interface PayFormPaymentStripe {
  paymentId?: string;
  currencyCode?: string;
  currencyDecimals: number;
  amount: number;
  amountFormatted?: string;
  amountFormattedWithCurrency?: string;
  countryCode?: string;
  correlationId?: string;
  operationCode?: string;
  payer?: PayFormPayer;
  status: PaymentStatus;
  providerPaymentMethodGroupCode?: string;
  collectBillingDetails?: boolean;
  paymentMethodChangeNumber?: number;
  stripeAmount: number;
  isSuccessful?: boolean;
  isPending?: boolean;
  paymentIntentId?: string;
}

export interface PayFormDataPaymentWeChat {
  isFinished?: boolean;
  amountFormatted?: string;
  stripePublicKey?: string;
  correlationId?: string;
}

export interface FpxPaymentInfoData {
  transactionDateTime?: Date;
  amountFormatted?: string;
  sellerOrderNumber?: string;
  fpxTransactionId?: string;
  buyerBankName?: string;
  transactionStatus?: string;
}

export interface BankTransferPaymentInfo {
  reference: string;
  financialAddresses: BankTransferFinancialAddresses[];
  amountFormattedWithCurrency: string;
  correlationId: string;
  finalizeDate: Date;
  productsSummary: PaymentProductsSummaryData;
  paymentStatus: PaymentStatus;
  redirectUrl?: string;
  remainingAmountFormattedWithCurrency?: string;
  overpaymentAmountFormattedWithCurrency?: string;
  acquiredAmountFormattedWithCurrency?: string;
  isFinished: boolean;
  statusPageAvailable?: boolean;
}

export interface BankTransferFinancialAddresses {
  supportedNetworks?: string[];
  type?: string;
  accountHolderName?: string;
  bic?: string;
  country?: string;
  iban?: string;
  accountNumber?: string;
  sortCode?: string;
  bankCode?: string;
  bankName?: string;
  clabe?: string;
  branchCode?: string;
  branchName?: string;
  accountType?: string;
}

export interface CreateMultibancoPaymentRequest {
  paymentId: string;
  payerEmail: string;
}

export interface MultibancoPaymentSourceResult {
  amountFormattedWithCurrency: string;
  entity: string;
  reference: string;
  correlationId: string;
  finalizeDate: Date;
  paymentStatus: PaymentStatus;
  redirectUrl?: string;
  isFinished: boolean;
  statusPageAvailable?: boolean;
  productsSummary: PaymentProductsSummaryData;
}

export interface CreateSubscriptionCustomerResult {
  clientSecret?: string;
  setupIntentId?: string;
  stripeErrorCode?: string;
  message?: string;
}

export interface CreateSubscriptionCustomerRequest {
  paymentMethodId: string;
  subscriptionId: string;
  stripePayerAddress?: StripePayerAddress;
}

export interface SubscriptionChangeResult {
  isSuccessful?: boolean;
  mandateConfirmation?: boolean;
  setupIntentId?: string;
  message?: string;
  clientUrl?: string;
  stripeErrorCode?: string;
  isTrialAlreadyUsed?: boolean;
  clientSecret?: string;
  requiresAction?: boolean;
  isPendingSetupIntent?: boolean;
}

export interface StartSubscriptionRequest {
  subscriptionId: string;
  setupIntentId?: string;
  paymentMethodId: string;
}

export interface RetrySubscriptionPaymentRequest {
  subscriptionId: string;
  paymentMethodId: string;
  subscriptionPayerAddress?: StripePayerAddress;
}

export interface StartUpdatePaymentMethodRequest {
  paymentMethodId: string;
  subscriptionId: string;
  token: string;
  subscriptionPayerAddress?: StripePayerAddress;
}

export interface ConfirmPaymentMethodUpdateRequest {
  setupIntentId: string;
  subscriptionId: string;
  token: string;
}

export interface ConfirmSubscriptionPaymentRequest {
  subscriptionId: string;
  token: string;
}

export interface SubscriptionFormDataStripe {
  isFinished?: boolean;
  stripePublicKey: string;
  accountCountry: string;
  transaction: StripeSubscriptionFormData;
  subscriptionInformation: SubscriptionInformation;
  isSubscriptionPastDue: boolean;
}

export interface StripeSubscriptionFormData {
  subscriptionId?: string;
  currencyCode?: string;
  currencyDecimals?: number;
  amount: number;
  amountFormatted?: string;
  amountFormattedWithCurrency?: string;
  countryCode?: string;
  correlationId?: string;
  payer?: PayFormPayer;
  status: SubscriptionStatus;
  providerPaymentMethodGroupCode?: string;
  productName?: string;
  productDescription?: string;
  planPricingIntervalUnit?: string;
  planPricingIntervalCount: number;
  planTrialIntervalUnit?: string;
  planTrialIntervalCount: number;
  discount?: Discount;
  payerId?: string;
  providerCode?: string;
  stripeAmount: number;
  discountedAmount?: string;
  discountAmount?: string;
  stripeDiscountedAmount?: number;
  cardLast4?: string;
}

export interface SubscriptionInformation {
  amount: string;
  operationCode: string;
  correlationId: string;
  countryCode: string;
  currency: string;
  providerConfigurationCode: string;
  paymentMethodGroup: string;
  subscriptionId: string;
  planId: string;
  productName: string;
  productDescription: string;
  intervalUnit: string;
  intervalCount: string;
  trialIntervalUnit: string;
  trialIntervalCount: string;
}
